import React, { useEffect, useState } from 'react'
import { UPPER_ARCH_TOOTH_NUMBERS } from '@constants/Settings/chartingPreferences.constants'
import { ToothNumberingSystem } from '@dataTypes/chartingPreferences.type'
import ToothNumberLabel from '@components/pages/Charting/Dental/ToothNumberLabel.component'
import {
  getToothSVGs,
  preloadToothSVGs,
} from '@components/pages/Charting/tooth-svgs/config/svg-registry'

interface ChartingPreferenceTeethPreviewProps {
  showToothNumber: boolean
  toothNumberingSystem: ToothNumberingSystem
}

const ChartingPreferenceTeethPreview = ({
  showToothNumber,
  toothNumberingSystem,
}: ChartingPreferenceTeethPreviewProps): React.ReactElement => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false
    const load = async (): Promise<void> => {
      await Promise.all(
        UPPER_ARCH_TOOTH_NUMBERS.flatMap((tooth) => [
          preloadToothSVGs(tooth, 'buccal'),
          preloadToothSVGs(tooth, 'crown-top'),
        ]),
      )
      if (!cancelled) {
        setReady(true)
      }
    }
    void load()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="settings-charting-preferences-preview">
      <div className="settings-charting-preferences-preview-row">
        {UPPER_ARCH_TOOTH_NUMBERS.map((tooth) => {
          const Buccal = getToothSVGs(tooth, 'buccal').Base
          const Crown = getToothSVGs(tooth, 'crown-top').Base
          return (
            <div
              key={`tooth-${tooth}`}
              className="settings-charting-preferences-tooth-col"
            >
              {showToothNumber && (
                <ToothNumberLabel
                  universalToothNumber={tooth}
                  numberingSystem={toothNumberingSystem}
                  className="settings-charting-preferences-tooth-label"
                />
              )}
              <div className="settings-charting-preferences-tooth-views">
                {ready ? (
                  <>
                    <Buccal className="settings-charting-preferences-tooth-svg" />
                    <Crown className="settings-charting-preferences-tooth-svg" />
                  </>
                ) : (
                  <div className="settings-charting-preferences-tooth-placeholder" />
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ChartingPreferenceTeethPreview
